import { configureStore } from '@reduxjs/toolkit';
import authenticationReducer from './slice/authentication';
import loadingReducer from './slice/loading';

export const store = configureStore({
  reducer: {
    authen: authenticationReducer,
    loading: loadingReducer
  },
});